import * as React from 'react';
import { FilterType, SavedFiltersType } from './types';
import { FilterDef, filtersComputeQueryFilter } from './Filters';
import { Menu } from '../menu/Menu';
import { MenuDivider } from '../menu/MenuDivider';
import { MenuItem } from '../menu/MenuItem';
import { Icon } from '../icon/Icon';
import { mcDelete, mcSave } from '@mc/react-ui-icons';
import { Button } from '../button/Button';
import { LAST_FILTER_ID, useFilters } from './useFilters';
import { useCallback } from 'react';

type Props = {
  type: FilterType;
  filtersDef: FilterDef[];
  settingsKey: string;
  visibleFields?: string[];
  buttonText?: string;
  onSetFilter: (
    formData: any,
    queryData: any,
    visibleFields?: string[]
  ) => void;
  formData?: any;
};

export const SavedFilters: React.FC<Props> = ({
  settingsKey,
  type,
  filtersDef,
  buttonText,
  visibleFields,
  onSetFilter,
  formData,
}) => {
  const filterHook = useFilters(settingsKey);

  const onSavedFilter = useCallback((filterItem: SavedFiltersType) => {
    const formData = filterItem.filter;
    const queryData = filtersComputeQueryFilter(type, formData, filtersDef);
    onSetFilter(
      formData,
      queryData,
      filterItem?.visibleFields ?? visibleFields
    );
  }, []);

  const savedFilterWithoutLastFilter = filterHook.savedFilters?.filter(
    (x) => x.id !== LAST_FILTER_ID
  );
  const lastFilter = filterHook.savedFilters?.find(
    (x) => x.id === LAST_FILTER_ID
  );
  const sortedSavedFilters = [
    ...(lastFilter ? [lastFilter] : []),
    ...savedFilterWithoutLastFilter,
  ];

  return (
    <Button
      style="primary"
      dropdown
      menu={
        <Menu>
          {sortedSavedFilters?.length > 0 && (
            <>
              <MenuDivider title={'Uložené filtry'} />
              {sortedSavedFilters?.map((filterItem) => (
                <MenuItem
                  //active={isEqual(formFilter, filterItem.filter)}
                  text={filterItem.nazev}
                  onClick={() => onSavedFilter(filterItem)}
                />
              ))}
              <MenuDivider />
            </>
          )}
          <MenuItem
            text={'Uložit filtr jako…'}
            icon={<Icon icon={mcSave} />}
            onClick={() => {
              filterHook.saveFilters(formData, visibleFields);
            }}
          />
          <MenuItem
            disabled={
              !filterHook.savedFilters || filterHook.savedFilters.length === 0
            }
            intent={'danger'}
            text={'Odstranit filtr'}
            onClick={() => {
              filterHook.removeSavedFilters(filterHook.savedFilters);
            }}
            icon={<Icon icon={mcDelete} />}
          />
        </Menu>
      }
    >
      {buttonText}
    </Button>
  );
};
